import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SpinnerService {

    visibility: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor() {
        setTimeout(() => { this.visibility = new BehaviorSubject(false); }, 0);
    }

    show() {
        setTimeout(() => { this.visibility.next(true); }, 1);
    }

    hide() {
        setTimeout(() => { this.visibility.next(false); }, 1);
    }
}
